import React from 'react';
import Help from './Help';
const HelpS = ({ color, ...props }) => (React.createElement(Help, Object.assign({ color: color, size: 24 }, props)));
HelpS.displayName = 'HelpS'; // Fix for tsc
export default HelpS;
//# sourceMappingURL=HelpS.js.map